import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import { sortMethods } from 'Root/../../shared/sorting'
import RemarksService from 'Services/remarks'

import { Text, FadedText } from 'Components/shared/Typography'

const CommentsContainer = styled.div`
  margin-top: 1em;
  overflow-y: auto;
  max-height: 155px;
`

const Comments = styled.div`
  display: table;
  border-spacing: 0 5px;
`

const CommentsRow = styled.div`
  display: table-row;
`

const CommentsCell = styled.div`
  display: table-cell;
`

export default ({ encounter }) => {
  const [remarks, setRemarks] = useState()

  useEffect(async () => {
    const allRemarks = await RemarksService.get({ encounterId: encounter.id, type: 'comments' })
    allRemarks.sort((a, b) => sortMethods.date(a.date, b.date))
    setRemarks(allRemarks)
  }, [encounter])

  return (
    <CommentsContainer>
      <Comments>
        {remarks?.map(item => (
          <CommentsRow>
            <CommentsCell style={{ whiteSpace: 'nowrap' }}>
              <FadedText small>
                {new Intl.DateTimeFormat('en', {
                  year: 'numeric',
                  month: 'numeric',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: 'numeric'
                }).format(new Date(item.date))}
              </FadedText>
            </CommentsCell>
            <CommentsCell
              style={{
                'padding-left': '2em'
              }}
            >
              <Text small>{item.text}</Text>
              <FadedText small> by {item.author}</FadedText>
            </CommentsCell>
          </CommentsRow>
        ))}
      </Comments>
    </CommentsContainer>
  )
}
